export const AuthorityUserMenu = [
  {
    title: "Dashboard",
    url: "/authority/dashboard",
    icon: "pi pi-th-large",
  },
  {
    title: "Cases List",
    url: "/authority/case/list",
    icon: "pi pi-home",
  },
];
